import React from 'react';
import { Clock, LogOut } from 'lucide-react';
import { Button } from '../ui/button';
import BrandAuthLayout from '../Brand/BrandAuthLayout';

export const PendingApproval = ({ user, onLogout }) => (
  <BrandAuthLayout strapline="Application received" testId="pending-approval-screen">
    <div className="space-y-4 text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gold/15">
        <Clock className="h-7 w-7 text-gold" />
      </div>
      <h1 className="text-lg text-cream">Thanks, your application is being reviewed</h1>
      <p className="text-sm text-cream/65" style={{ textTransform: 'none' }}>
        {user?.name ? `${user.name}, ` : ''}we've got your details and the office will be in touch shortly.
        You'll see jobs here as soon as your account is approved.
      </p>
      <Button
        variant="outline"
        onClick={onLogout}
        className="w-full border-gold/30 bg-transparent text-cream hover:bg-white/10 hover:text-cream"
        data-testid="pending-logout-btn"
      >
        <LogOut className="mr-2 h-4 w-4" /> Sign out
      </Button>
    </div>
  </BrandAuthLayout>
);

export default PendingApproval;
